import { Box, Divider } from '@mui/material'
import React, { useCallback } from 'react'
import { TemplateHierarchy, TemplatePromotedContent } from '../../../components'
import { useTemplateFormContext } from '../template-form-context'
import { useStyles } from './style'

const Structure = () => {
  const classes = useStyles()
  const { template, setTemplate } = useTemplateFormContext()

  const updateTemplatePromotedContentMode = useCallback((mode) => {
    setTemplate(template => ({ ...template, promotedContentMode: mode }))
  }, [setTemplate])

  return (
    <Box className={classes.root}>
      <TemplateHierarchy template={template} />
      <Box mb={3} />
      <Divider sx={{ mb: 2 }} />
      <TemplatePromotedContent template={template} onPromotedContentModeChanged={updateTemplatePromotedContentMode} />
    </Box>
  )
}

export default Structure
